<template>
  <div>
    <div class="row justify-content-center mt-5">
      <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12 justify-content-center">
        <img src="@/assets/img/media-background.png" :alt="$t('IntroMediaSection.media-background')" />
      </div>
      <div class="h2 col-lg-8 col-md-7 col-sm-12 col-xs-12 justify-content-center text-center text-black media-banner-title">
        {{ $t('IntroMediaSection.search-and-filter-to-find-the-video-collection-or-file-youre-looking-for') }}
      </div>
    </div>
    <div class="row">
      <div class="col-lg-2 offset-5 text-center mt-4">
        <button id="dismiss" data-test="dismiss" class="btn btn-success btn-lg" @click="$emit('dismiss')">
          <i class="fas fa-check"></i>
          {{ $t('IntroMediaSection.dismiss') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'IntroMediaSection',
};
</script>
